import {MuWidget} from "mu-widget/lib/MuWidget";
import {MuUIDs} from "mu-widget/lib/MuUIDs";
import {Objects} from "../Utils";

//todo: ikona
export class UiChboxList extends MuWidget {
	// @ts-ignore
	public htmlName: string;

	public selectedItem: UiChboxListItem| null = null;

	beforeIndex() {
		/* this.muAppendContent(`<label mu-template="item" mu-widget="UiChboxListItem">
			<input type="checkbox" mu-id="input">
			<!-- <img mu-id="icon" /> -->
			<span mu-id="title"></span>
		</label>`); */
		this.htmlName = MuUIDs.next("name");
		this.muRegisterEvent('change');
	}

	afterIndex() {
		if (!('item' in this.muTemplates)) {
			this.muTemplates.item = `<label mu-widget="UiChboxListItem">
			<input type="checkbox" mu-id="input">
			<span mu-id="title"></span>
		</label>`
		}
	}

	public checkBy(checkedCallback :(item: UiChboxListItem) => undefined|boolean) {
		for(const item of Object.values(this.items)) {
			const res = checkedCallback(item);
			if (res !== undefined) item.ui.input.checked = res;
		}
	}


	public items: Record<string, UiChboxListItem> = {};

	public bindItems(items: ChboxListItem[]|Record<string, string | ChboxListItem>)
	{
		this.container.innerHTML = "";
		this.items = {};

		if (Array.isArray(items)) {
			for(const item of items)
				this.replaceItem(item);
		} else {
			for(const k in items) {
				let item = items[k];
				this.replaceItem((typeof item === "string")
					? {
						id: k,
						title: item,
					}
					: item
				);
			}
		}
	}

	public replaceItem(item: ChboxListItem|(Partial<ChboxListItem>&{id:ChboxListItemId})) {
		if (!this.items[item.id]) {
			// @ts-ignore
			this.items[item.id] = this.muWidgetFromTemplate('item', this.container, item) as UiChboxListItem;
			if (this._value == item.id) this.value = this._value;
		} else {
			Object.assign(this.items[item.id], item);
			this.items[item.id].afterIndex();
		}
	}

	onChanged() {
		this.muDispatchEvent('change', this.value);
	}

	public get value() {
		const res: ChboxListItemId[] = [];
		for(const k in this.items) {
			if (this.items[k].getChecked())
				res.push(k);
		}

		return res;
	}

	public set value(v: ChboxListItemId[]|null) {
		v = v || [];
		for(const k in this.items) {
			this.items[k].setChecked(v.includes(k));
		}
	}

	muBindData(srcData: any) {
		this.value = srcData;
	}

	muFetchData() {
		return this.value;
	}

	setDisabled(disabled: boolean) {
		for(const k in this.items) {
			this.items[k].ui.input.disabled = disabled;
		}
	}
}

export class UiChboxListItem
		extends MuWidget<UiChboxList, {input: HTMLInputElement, title: HTMLElement}>
		implements ChboxListItem {

	disabled: boolean = false;
	// @ts-ignore
	public id: ChboxListItemId;
	public title: string|any;

	afterIndex() {
		this.ui.input.name = this.muParent.htmlName;
		this.ui.input.value = this.id;
		this.ui.input.disabled = this.disabled;
		// if (typeof this.title === "string")
		if (typeof this.title === "string") {
			this.ui.title.innerText = this.title;
		} else {
			this.muBindData(this.title);
		}
	}

	input_change() {
		this.muParent.onChanged();
	}

	setChecked(checked: boolean): void {
		this.ui.input.checked = checked;
	}

	getChecked(): boolean {
		return this.ui.input.checked;
	}
}

export type ChboxListItemId = string;

export type ChboxListItem = {
	id: ChboxListItemId;
	title: string|any;
	disabled?: boolean;
	// iconImage: string;
}